import React, { useState, useRef, useEffect } from 'react';
import './MenuDropdown.css';

const MenuDropdown = ({ options, onSelect }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleOptionClick = (option) => {
    if (option.onClick) {
      option.onClick();
    } else if (onSelect) {
      onSelect(option);
    }
    setIsOpen(false);
  };

  return (
    <div className="menu-dropdown-container" ref={dropdownRef}>
      <button 
        className="menu-dropdown-button" 
        onClick={() => setIsOpen(!isOpen)}
      >
        <span>Options</span>
        <span className={`menu-dropdown-arrow ${isOpen ? 'open' : ''}`}>
          {isOpen ? '✓' : '›'}
        </span>
      </button>
      
      {isOpen && (
        <div className="menu-dropdown-content">
          {options.map((option, index) => (
            <button
              key={index}
              className="menu-dropdown-item"
              onClick={() => handleOptionClick(option)}
            >
              {option.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default MenuDropdown;
